import React, { memo, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'layout/atoms/Loader/Loader';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import SpecificationCard from 'layout/molecules/SpecificationCard';
import Grid from 'molecules/Grid/Grid';
import { fetchSpecifications, resetSpecifications, selectSpecificationsStatus, setFilter, } from 'store/specificationsSlice';
function AllSpecifications({ orderSelect = false, warehouseReleaseSelect = false, latest = false, drafts = false, }) {
    const dispatch = useDispatch();
    const layout = useSelector((state) => state.layout.specificationsDashboard);
    const { t } = useTranslation(['specification', 'exceptions']);
    const specifications = useSelector((state) => state.specifications.items);
    const filters = useSelector((state) => state.specifications.filters);
    const pageInfo = useSelector((state) => state.specifications.pageInfo);
    const fetchStatus = useSelector(selectSpecificationsStatus).fetch;
    const refetch = useSelector((state) => state.specifications.refetchFlags.fetch);
    const productionSpecifications = specifications.filter((spec) => spec.state === 'PRODUCTION');
    const draftSpecifications = specifications.filter((spec) => spec.state === 'DRAFT');
    const displayedSpecifications = orderSelect || warehouseReleaseSelect ? productionSpecifications : specifications;
    let stateFilter = null;
    if (drafts) {
        stateFilter = 'DRAFT';
    }
    else if (orderSelect || warehouseReleaseSelect) {
        stateFilter = 'PRODUCTION';
    }
    const clearAndFetchSpecifications = useCallback(() => {
        dispatch(resetSpecifications());
        dispatch(fetchSpecifications({ states: stateFilter ? [stateFilter] : null }));
    }, [dispatch, stateFilter]);
    useEffect(() => {
        if (refetch) {
            clearAndFetchSpecifications();
        }
    }, [refetch, clearAndFetchSpecifications]);
    const fetchMoreSpecifications = () => {
        if (pageInfo.hasNextPage && fetchStatus !== 'loading') {
            dispatch(fetchSpecifications({ states: stateFilter ? [stateFilter] : null }));
        }
    };
    useEffect(() => {
        if (latest) {
            dispatch(setFilter({ filterName: 'orderBy', value: '-createdDate' }));
        }
    }, [dispatch, latest, displayedSpecifications]);
    useEffect(() => {
        if (filters) {
            clearAndFetchSpecifications();
        }
    }, [dispatch, filters, clearAndFetchSpecifications]);
    if (fetchStatus === 'idle' || fetchStatus === 'loading') {
        return React.createElement(Loader, null);
    }
    if (fetchStatus === 'succeeded' &&
        displayedSpecifications.length === 0 &&
        filters.search !== '') {
        return React.createElement(EmptyState, null);
    }
    if (drafts) {
        return (React.createElement(InfiniteScroll, { dataLength: draftSpecifications.length, next: fetchMoreSpecifications, hasMore: pageInfo.hasNextPage, loader: React.createElement(Loader, null), scrollableTarget: "mainContent" },
            React.createElement(Grid, { columns: layout === 'grid' ? 5 : 1, gap: 12 },
                draftSpecifications.length === 0 && (React.createElement("p", null, t('emptyStates:no_filters_found_for_products'))),
                draftSpecifications.map((specification) => {
                    return (React.createElement(SpecificationCard, { key: specification.id, specification: specification, layout: layout, orderSelect: orderSelect, warehouseReleaseSelect: warehouseReleaseSelect }));
                }))));
    }
    return (React.createElement(InfiniteScroll, { dataLength: displayedSpecifications.length, next: fetchMoreSpecifications, hasMore: pageInfo.hasNextPage, loader: React.createElement(Loader, null), scrollableTarget: "mainContent" },
        React.createElement(Grid, { columns: layout === 'grid' ? 'flexible' : 1, gap: 12 },
            displayedSpecifications.length === 0 && (React.createElement("p", null, t('emptyStates:no_filters_found_for_products'))),
            displayedSpecifications.map((specification) => {
                return (React.createElement(SpecificationCard, { key: specification.id, specification: specification, layout: layout, orderSelect: orderSelect, warehouseReleaseSelect: warehouseReleaseSelect }));
            }))));
}
export default memo(AllSpecifications);
